export const border = () => {
  const borderRadius = `
    --border-radius-2: 0.2rem;
    --border-radius-4: 0.4rem;
    --border-radius-8: 0.8rem;
    --border-radius-10: 1.0rem;
    --border-radius-16: 1.6rem;
    --border-radius-32: 3.2rem;
    --border-radius-64: 6.4rem;
  `;

  return borderRadius;
};
